import React from "react";
import { SpaceBetween, StatusIndicator } from "@amzn/awsui-components-react";
import type { StatusIndicatorProps } from "@amzn/awsui-components-react";
import { AssistantStep } from "features/assistant/definitions";

const STATUS_TYPE: Record<AssistantStep["status"], StatusIndicatorProps.Type> =
  {
    completed: "success",
    inProgress: "in-progress",
    failed: "error",
  };

const StepsContent: React.FC<{ steps: AssistantStep[] }> = ({ steps }) => (
  <SpaceBetween size="xxs">
    {steps.map((step, i) => (
      <StatusIndicator
        key={`${step.stepName}-${i}`}
        type={STATUS_TYPE[step.status]}
      >
        {step.stepName}
      </StatusIndicator>
    ))}
  </SpaceBetween>
);

export default StepsContent;
